<template src="./Doctors.html" />

<script>
import { useStore } from "@/store/store.js"
import mixins from "@/Mixins.js"
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue"

export default {
  components: { WholeMultiselect },
  mixins: [mixins],
  data() {
    return {
      doctorsAdd: [],
      newDoctorsAdd: [],
      doctorAdd: {
        name: "",
        crmNumber: "",
        crmState: "",
        email: "",
        cpf: "",
        password: "",
      },
      isProject: false,
      specialties: [],
      popupAddDoctor: false,
      titlePopUp: "",
      doctors: [],
      colLength: 4,
      doctorsTotalPages: 1,
      popupIsEditDoctor: false,
      specialtiesDoctorTable: [],
      specialtiesDoctorTableFinal: [],
      popupAddLinkedDoctor: false,
      typedWord: "",
      doctorsSearch: [],
      disabledConfirmButton: true,
      doctorSelected: [],
      doctorId: null,
      notSchedule: false,
      doctorAttendanceDataAdd: [],
      attendanceTypes: [],
      specialtiesDoctorTableTemp: [],
      webClinic: {},
      optionsAttendanceType: [
        { text: "Presencial", value: 1 },
        { text: "Por vídeo", value: 2 },
      ],
      optionsWeekDays: [
        {
          text: "Seg",
          value: "MONDAY",
        },
        {
          text: "Ter",
          value: "TUESDAY",
        },
        {
          text: "Qua",
          value: "WEDNESDAY",
        },
        {
          text: "Qui",
          value: "THURSDAY",
        },
        {
          text: "Sex",
          value: "FRIDAY",
        },
        {
          text: "Sáb",
          value: "SATURDAY",
        },
      ],
      currentx: 1,
      numPages: 0,
      pagination: false,
      windowWidth: 0,
      showDoctorsList: false,
      specialtyClassDanger: [],
      checkSpecialty: false,
      doctorIdToDelete: 0,
      plans: [],
      invalidFields: {
        name: false,
        email: false,
        crmNumber: false,
        crmState: false,
        password: false,
        passwordConfirm: false,
        address: false,
      },
      dangerMessages: {
        name: "",
        email: "",
        crmNumber: "",
        crmState: "",
        password: "",
        passwordConfirm: "",
      },
      stateAcronyms: [
        "AC","AL","AP","AM",
        "BA","CE","DF","ES",
        "GO","MA","MT","MS",
        "MG","PA","PB","PR",
        "PE","PI","RR","RO",
        "RJ","RN","RS","SC",
        "SP","SE","TO",
      ],
      attendanceTypeNotFilled: [],
      workDaysNotInformed: [],
      attendancePeriodNotInformed: [],
      priceNotInformed: [],
      attendancePeriodMessage: [],
      minimumValueMessage: [],
      specialtyToRemoveIndex: null,
      passwordType: "password",
      eyeIconType: "eye-slash",
      passwordConfirmType: "password",
      eyeIconTypePasswordConfirm: "eye-slash",
      showLoginTooltipInfo: true,
      showPasswordInputs: true,
      valueCheckbox: true,
      toRerenderAttendanceType: 0,
      openAgendaForAppointments: [],
      isSaving: false,
    };
  },
  
  setup () {
    const store = useStore()

    return {
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },

  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  mounted: function () {
    const vm = this;
    vm.init();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    currentx: function () {
      const vm = this;
      vm.getDoctorsAfterSearch();

    },
    popupAddDoctor: function (newVal) {
      const vm = this;
      if (newVal == false) {
        vm.getDoctors();
      }
    },
    "doctorAdd.name": function (newVal) {
      const vm = this;
      if (vm.testNullUndefinedEmpty(vm.doctorAdd.email) || !vm.popupIsEditDoctor) {
        const domain = "@filoof.com.br";
        if (!vm.testNullUndefinedEmpty(newVal)) {
          const nameSplit = newVal
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .split(" ");
          const firstName = nameSplit[0];
          const data = new Date();
          const min = data.getMinutes().toString();
          const hora = data.getHours().toString();
          vm.doctorAdd.email = firstName + hora + min + domain;
        } else {
          vm.doctorAdd.email = "";
        }
      }
    },
    "doctorAdd.password": function () {
      const vm = this;
      vm.invalidFields.password = false;
      vm.invalidFields.passwordConfirm = false;
    },
  },
  methods: {
    init() {
      const vm = this;
      vm.getSpecialties();
      vm.getDoctors();
      vm.getPlans();
      vm.getIsProject();
    },
    handleResize() {
      const vm = this;
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        vm.showLoginTooltipInfo = false;
      } else {
        vm.showLoginTooltipInfo = true;
      }
      vm.windowWidth = window.innerWidth;
    },
    passwordVisibility() {
      const vm = this;
      if (vm.passwordType === "password") {
        vm.passwordType = "text";
        vm.eyeIconType = "eye";
      } else {
        vm.passwordType = "password";
        vm.eyeIconType = "eye-slash";
      }
    },
    passwordConfirmVisibility() {
      const vm = this;
      if (vm.passwordConfirmType === "password") {
        vm.passwordConfirmType = "text";
        vm.eyeIconTypePasswordConfirm = "eye";
      } else {
        vm.passwordConfirmType = "password";
        vm.eyeIconTypePasswordConfirm = "eye-slash";
      }
    },
    clickAddNewDoctor() {
      const vm = this;
      vm.getDoctors();
      vm.$bvModal.show("doctors-popup-doctor");
      vm.popupIsEditDoctor = false;
      vm.showPasswordInputs = true;
      vm.titlePopUp = "Adicionar novo médico";
      vm.countAddSpecialtyDoctor = 0;
      vm.doctorAdd.name = "";
      vm.doctorAdd.crmNumber = "";
      vm.doctorAdd.crmState = "";
      vm.doctorAdd.email = "";
      vm.doctorAdd.passwordConfirm = null;
      vm.doctorAdd.password = null;
      vm.doctorAttendanceDataAdd = [];
      vm.passwordType = "password";
      vm.eyeIconType = "eye-slash";
      vm.passwordConfirmType = "password";
      vm.eyeIconTypePasswordConfirm = "eye-slash";
      vm.clearInvalidFields();

    },
    clearInvalidFields(){
      const vm = this;
      vm.specialtyClassDanger = [];
      vm.attendanceTypeNotFilled = [];
      vm.workDaysNotInformed = [];
      vm.attendancePeriodNotInformed = [];
      vm.priceNotInformed = [];
      vm.attendancePeriodMessage = [];
      vm.minimumValueMessage = [];
      vm.invalidFields.name = false;
      vm.invalidFields.email = false;
      vm.invalidFields.crmNumber = false;
      vm.invalidFields.crmState = false;
      vm.invalidFields.password = false;
      vm.invalidFields.passwordConfirm = false;
      vm.dangerMessages.name = "";
      vm.dangerMessages.email = "";
      vm.dangerMessages.crmNumber = "";
      vm.dangerMessages.crmState = "";
      vm.dangerMessages.password = "";
      vm.dangerMessages.passwordConfirm = "";

    },
    handleSelected(tr) {
      const vm = this;
      vm.disabledConfirmButton = false;
      vm.doctorId = tr.id;
      vm.doctorSelected = tr;
    },
    confirmDeletion(id) {
      const vm = this;
      vm.doctorIdToDelete = id;
      vm.$bvModal.show("modal-confirm-doctor-deletion");
      setTimeout(() => {
        const buttonNoDeletion = document.getElementById(
          "button-cancel-doctor-deletion"
        );
        buttonNoDeletion.focus();
      }, 250);
    },
    deleteDoctor() {
      const vm = this;
      vm.$bvModal.hide("modal-confirm-doctor-deletion");
      vm.axios
        .delete(
          vm.$store.state.filooServer + "clinic-doctors/" + vm.doctorIdToDelete,
          {
            headers: {
              Authorization: vm.$session.get("bearer"),
            },
          }
        )
        .then(function (response) {
          if (response.status === 204) {
            vm.showNotifySuccess(
              "Operação realizada",
              "Profissional da saúde desvinculado com sucesso!",
              4000
            );
            vm.$nextTick(() => {
              vm.getDoctors();
            });
          }
        })
        .catch(function (error) {
          vm.showNotifyError(
            "O profissional da saúde não pode ser removido",
            6000
          );
          console.error({
            error: error,
            endpoint: "clinic-doctors/" + vm.doctorIdToDelete,
            method: "deleteDoctor",
            http_method: "delete",
          });
        });
    },
    confirmDoctor() {
      const vm = this;
      vm.axios
        .post(
          vm.$store.state.filooServer + "clinic-doctors/doctors/" + vm.doctorId,
          vm.doctorSelected,
          {
            headers: {
              Authorization: vm.$session.get("bearer"),
            },
          }
        )
        .then(function (response) {
          if (response.status === 201) {
            vm.showNotifySuccess(
              "Operação realizada",
              "O profissional da saúde <b><i>" +
                vm.doctorSelected.name +
                "</i></b> foi adicionado com sucesso!",
              4000
            );
            vm.$bvModal.hide("doctors-popup-linked-doctor");
            vm.getDoctors();
          }
        })
        .catch(function (error) {
          if (error.status === 412) {
            vm.showNotifyWarning(
              "O profissional da saúde <b><i>" +
                vm.doctorSelected.name +
                "</i></b> não pode ser adicionado pois já consta no corpo clínico.",
              4000
            );
          } else if (error.status == 404) {
            vm.showNotifyWarning(
              "O profissional da saúde <b><i>" +
                vm.doctorSelected.name +
                "</i></b> não pode ser adicionado pois não está ativo.",
              4000
            );
          } else {
            vm.showNotifyError(
              "O profissional da saúde <b><i>" +
                vm.doctorSelected.name +
                "</i></b> não pode ser adicionado",
              6000
            );
          }
          console.error({
            error: error,
            endpoint: "clinic-doctors/doctors/" + vm.doctorId,
            method: "confirmDoctor",
            http_method: "POST",
            sent_object: vm.doctorSelected,
          });
        });
    },
    validateAdditionDoctor() {
      const vm = this;
      let validFields = true;
      let specialtiesNull = false;
      let hourValid = true;
      let weekDaysValid = true;
      let valueMinAppointmentValid = true;
      let attendanceTypeFill = true;
      if (vm.testNullUndefinedEmpty(vm.doctorAdd.name)) {
        validFields = false;
        vm.invalidFields.name = true;
        vm.dangerMessages.name = "Campo obrigatório";
      } else if (vm.testValidName(vm.doctorsAdd.name)) {
        validFields = false;
        vm.invalidFields.name = true;
        vm.dangerMessages.name = "Digite o nome completo";
      }
      const stateCheck = vm.stateAcronyms.filter(
        (state) => !state.localeCompare(vm.doctorAdd.crmState)
      );
      if (vm.testNullUndefinedEmpty(vm.doctorAdd.crmState)) {
        validFields = false;
        vm.invalidFields.crmState = true;
        vm.dangerMessages.crmState = "Campo obrigatório";
      } else if (stateCheck.length === 0) {
        validFields = false;
        vm.invalidFields.crmState = true;
        vm.dangerMessages.crmState = "Estado inválido";
      }
      if (vm.testNullUndefinedEmpty(vm.doctorAdd.crmNumber)) {
        validFields = false;
        vm.invalidFields.crmNumber = true;
        vm.dangerMessages.crmNumber = "Campo obrigatório";
      } else if (vm.doctorAdd.crmNumber.length < 4) {
        validFields = false;
        vm.invalidFields.crmNumber = true;
        vm.dangerMessages.crmNumber = "Número CRM inválido";
      }
      if(vm.showPasswordInputs){
        if (
          vm.testNullUndefinedEmpty(vm.doctorAdd.password)
        ) {
          validFields = false;
          vm.invalidFields.password = true;
          vm.invalidFields.passwordConfirm = true;
          vm.dangerMessages.password = "Campo obrigatório";
          vm.dangerMessages.passwordConfirm = "Campo obrigatório";
          vm.showNotifyWarning("A senha e confirmação de senha são campos obrigatórios", 3000);
          vm.$refs.focusPassword.focus();
        } else {
          if (vm.doctorAdd.password.length < 8) {
            vm.showNotifyWarning("A senha e deve conter ao menos 8 dígitos", 3000);
            vm.invalidFields.password = true;
            vm.invalidFields.passwordConfirm = true;
            vm.dangerMessages.password = "Senha inválida";
            vm.dangerMessages.passwordConfirm = "Confirmação de senha inválida";
            validFields = false;
            vm.$refs.focusPassword.focus();
          }
          if (
            vm.doctorAdd.password != vm.doctorAdd.passwordConfirm
          ) {
            vm.showNotifyWarning("A senha e confirmação de senha divergentes", 3000);
            vm.invalidFields.password = true;
            vm.invalidFields.passwordConfirm = true;
            vm.dangerMessages.password = "Senha e confirmação de senha divergentes";
            vm.dangerMessages.passwordConfirm = "Senha e confirmação de senha divergentes";
            validFields = false;
            vm.$refs.focusPasswordConfirm.focus();
          }
        }
      }

      for (const index in vm.doctorAttendanceDataAdd) {
        vm.specialtyClassDanger.push(false);
        vm.attendanceTypeNotFilled.push(false);
        vm.workDaysNotInformed.push(false);
        vm.attendancePeriodNotInformed.push(false);
        vm.priceNotInformed.push(false);
        vm.attendancePeriodMessage.push("");
        vm.minimumValueMessage.push("");
        if (
          vm.testNullUndefinedEmpty(
            vm.doctorAttendanceDataAdd[index].attendanceType
          )
        ) {
          if (vm.openAgendaForAppointments[index]) {
            attendanceTypeFill = false;
            vm.attendanceTypeNotFilled[index] = true;
          }
        }
        if (
          vm.testNullUndefinedEmpty(vm.doctorAttendanceDataAdd[index].price)
        ) {
          if (vm.openAgendaForAppointments[index]) {
            valueMinAppointmentValid = false;
            vm.priceNotInformed[index] = true;
            vm.minimumValueMessage[index] = "Campo obrigatório";
          }
        } else if (
          parseFloat(
            vm.doctorAttendanceDataAdd[index].price.replace(",", ".")
          ) < 10
        ) {
          if (vm.openAgendaForAppointments[index] !== true) {
            valueMinAppointmentValid = false;
            vm.priceNotInformed[index] = true;
            vm.minimumValueMessage[index] = "Valor mínimo R$ 10,00";
          }
        }
        if (
          vm.testNullUndefinedEmpty(vm.doctorAttendanceDataAdd[index].specialty)
        ) {
          specialtiesNull = true;
          vm.specialtyClassDanger[index] = true;
        }
        vm.validateAddressFields(vm.doctorAttendanceDataAdd[index].address, vm.doctorAttendanceDataAdd[index].attendanceType);
      }
      if (hourValid == false) validFields = false;
      if (attendanceTypeFill == false) validFields = false;
      if (valueMinAppointmentValid == false) validFields = false;
      if (weekDaysValid == false) validFields = false;
      if (specialtiesNull == true) validFields = false;
      if (vm.invalidFields.address) validFields = false;
      if (validFields == true) {
        vm.popupIsEditDoctor ? vm.saveChangesDoctor() : vm.postNewDoctor();
      }
    },
    isHour(hour) {
      const vm = this;
      if (vm.testNullUndefinedEmpty(hour)) {
        return false;
      } else {
        const hourArray = hour.split(":");
        const partOne = hourArray[0];
        const parttTwo = hourArray[1];
        const intPartOne = parseFloat(partOne);
        const intPartTwo = parseFloat(parttTwo);
        if (intPartOne > 23 || intPartTwo > 59) {
          return false;
        } else {
          return true;
        }
      }
    },
    cancelAdditionDoctor() {
      const vm = this;
      vm.getDoctors();
      vm.$bvModal.hide("doctors-popup-doctor");
    },
    getDoctors() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "clinic-doctors/doctors", {
          headers: {
            Authorization: vm.$session.get("bearer"),
          },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.doctors = response.data.content;
            vm.doctorsTotalPages = response.data.totalPages;
            for (const index in vm.doctors) {
              if (vm.testNullUndefinedEmpty(vm.doctors[index].doctor.name)) {
                vm.doctors[index].nameDoctor = "Não definido";
              } else {
                vm.doctors[index].nameDoctor = vm.doctors[index].doctor.name;
              }
              if (
                vm.testNullUndefinedEmpty(vm.doctors[index].doctor.crmNumber)
              ) {
                vm.doctors[index].crmNumberDoctor = vm.doctors[
                  index
                ].nameDoctor = "Não definido";
              } else {
                vm.doctors[index].crmNumberDoctor =
                  vm.doctors[index].doctor.crmNumber;
              }
              if (
                vm.testNullUndefinedEmpty(vm.doctors[index].doctor.crmState)
              ) {
                vm.doctors[index].crmStateDoctor = "";
              } else {
                vm.doctors[index].crmStateDoctor =
                  "- " + vm.doctors[index].doctor.crmState.toUpperCase();
              }
            }
          }
        })
        .catch(function (error) {
          vm.showNotifyError(
            "Não foi possível listar os profissionais da saúde",
            6000
          );
          console.error({
            error: error,
            endpoint: "clinic-doctors/doctors",
            method: "getDoctors",
            http_method: "GET",
          });
        });
    },
    addSpecialtyDoctor() {
      const vm = this;
      vm.doctorAttendanceDataAdd.push({
        address: {
          zipcode: "",
          city: "",
          complement: "",
          neighborhood: "",
          number: "",
          state: "",
          street: "",
          enableAddressStreet: false,
          invalidFields: {
            zipcode: true,
            city: true,
            street: true,
            state: true,
          }
        }
      });
    },
    removeSpecialtyDoctor() {
      const vm = this;
      setTimeout(function () {
        vm.doctorAttendanceDataAdd.splice(vm.specialtyToRemoveIndex, 1);
        vm.specialtyClassDanger.splice(vm.specialtyToRemoveIndex, 1);
        vm.attendanceTypeNotFilled.splice(vm.specialtyToRemoveIndex, 1);
        vm.workDaysNotInformed.splice(vm.specialtyToRemoveIndex, 1);
        vm.attendancePeriodNotInformed.splice(vm.specialtyToRemoveIndex, 1);
        vm.priceNotInformed.splice(vm.specialtyToRemoveIndex, 1);
        vm.attendancePeriodMessage.splice(vm.specialtyToRemoveIndex, 1);
        vm.minimumValueMessage.splice(vm.specialtyToRemoveIndex, 1);
        vm.openAgendaForAppointments.splice(vm.specialtyToRemoveIndex, 1);
        vm.$bvModal.hide("modal-remove-specialty");
      }, 700);
    },
    getSpecialties() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "specialties", {
          headers: {
            Authorization: vm.$session.get("bearer"),
          },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.specialties = response.data;
          }
        })
        .catch(function (error) {
          console.log(error.response.data);
        });
    },
    getDoctorsAfterSearch() {
      const vm = this;
      vm.disabledConfirmButton = true;
      const page = vm.currentx - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "admin/doctors?page=" +
            page +
            "&search=" +
            vm.typedWord +
            "&size=5&sort=id,asc",
          {
            headers: {
              Authorization: vm.$session.get("bearer"),
            },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.showDoctorsList = true;
            vm.doctorsSearch = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
          }
        })
        .catch(function (error) {
          vm.showDoctorsList = false;
          vm.showNotifyError(
            "Não foi possível encontrar e listar os profissionais da saúde",
            6000
          );
          console.error({
            error: error,
            endpoint:
              "admin/doctors?page=" +
              page +
              "&search=" +
              vm.typedWord +
              "&size=5&sort=id,asc",
            method: "getDoctorsAfterSearch",
            http_method: "GET",
          });
        });
    },
    clickAddLinkedDoctor() {
      const vm = this;
      vm.disabledConfirmButton = true;
      vm.$bvModal.show("doctors-popup-linked-doctor");
      vm.showDoctorsList = false;
      vm.doctorsSearch = [];
      vm.doctorSelected = null;
      vm.typedWord = "";
    },
    editDoctor(data) {
      const vm = this;
      const doctor = data.doctor;
      vm.showPasswordInputs = false;
      vm.titlePopUp = "Gerenciar especialidades: " + doctor.name;
      vm.popupIsEditDoctor = true;
      vm.doctorAdd.name = doctor.name;
      vm.doctorAdd.crmNumber = doctor.crmNumber;
      vm.doctorAdd.crmState = doctor.crmState;
      vm.doctorAdd.email = doctor.email;
      vm.doctorAdd.cpf = doctor.cpf;
      vm.doctorAdd.passwordConfirm = doctor.password;
      vm.doctorAdd.password = null;
      vm.doctorAttendanceDataAdd = data.attendances;
      vm.webClinic = data;
      for (const a in data.attendances) {
        vm.countAddSpecialtyDoctor += 1;
        vm.doctorAttendanceDataAdd[a].specialty = data.attendances[a].specialty;
        vm.doctorAttendanceDataAdd[a].attendanceType =
          data.attendances[a].attendanceType;
        vm.doctorAttendanceDataAdd[a].price = vm.maskMoneyWithoutStyle(
          data.attendances[a].price
        );
        vm.doctorAttendanceDataAdd[a].priceWithoutDiscount =  vm.maskMoneyWithoutStyle(
          data.attendances[a].priceWithoutDiscount
        );
        vm.openAgendaForAppointments[a] = !data.attendances[a].ignoreMatch;
        if (vm.testNullUndefinedEmpty(data.attendances[a].address)) {
          data.attendances[a].address = {
            zipcode: null,
            city: null,
            complement: null,
            neighborhood: null,
            number: null,
            state: null,
            street: null,
            enableAddressStreet: false,
            invalidFields: {
              zipcode: true,
              city: true,
              street: true,
              state: true,
            }
          }
        } else {
          data.attendances[a].address.enableAddressStreet = true,
          data.attendances[a].address.invalidFields = {
              zipcode: false,
              city: false,
              street: false,
              state: false,
            }
        }
      }
      vm.passwordType = "password";
      vm.eyeIconType = "eye-slash";
      vm.passwordConfirmType = "password";
      vm.eyeIconTypePasswordConfirm = "eye-slash";
      vm.clearInvalidFields();
      vm.$bvModal.show("doctors-popup-doctor");
    },
    saveChangesDoctor() {
      const vm = this;
      if (vm.isSaving) return;
      vm.isSaving = true;
      vm.webClinic.doctor.name = vm.doctorAdd.name;
      vm.webClinic.doctor.crmNumber = vm.doctorAdd.crmNumber;
      vm.webClinic.doctor.crmState = vm.doctorAdd.crmState;
      vm.webClinic.doctor.cpf = vm.doctorAdd.cpf;
      vm.webClinic.doctor.email = vm.doctorAdd.email;
      vm.webClinic.doctor.password =
        vm.doctorAdd.password != "" ? vm.doctorAdd.password : null;
        

      for (const a in vm.doctorAttendanceDataAdd) {
        console.log(vm.doctorAttendanceDataAdd[a].priceWithoutDiscount)
        vm.doctorAttendanceDataAdd[a].price =
          vm.testNullUndefinedEmpty(vm.doctorAttendanceDataAdd[a].price) ===
          false
            ? vm.doctorAttendanceDataAdd[a].price.replace(",", ".")
            : null;
            vm.doctorAttendanceDataAdd[a].priceWithoutDiscount =
          vm.testNullUndefinedEmpty(vm.doctorAttendanceDataAdd[a].priceWithoutDiscount) ===
          false
            ? vm.doctorAttendanceDataAdd[a].priceWithoutDiscount.replace(",", ".")
            : null;
      }
      const attendancesFinal = [];
      for (const index in vm.doctorAttendanceDataAdd) {
        attendancesFinal.push({
          webClinicId: vm.$session.get("clinicId"),
          attendanceType: vm.doctorAttendanceDataAdd[index].attendanceType,
          ignoreMatch:
            vm.openAgendaForAppointments[index]
              ? false
              : true,
          price:
            vm.openAgendaForAppointments[index] == false
              ? null
              : vm.doctorAttendanceDataAdd[index].price.replace(",", "."),
              priceWithoutDiscount:
            vm.openAgendaForAppointments[index] == false
              ? null
              : vm.doctorAttendanceDataAdd[index].priceWithoutDiscount === null || "" || undefined ? null : vm.doctorAttendanceDataAdd[index].priceWithoutDiscount.replace(",", "."),
          initial:
            vm.openAgendaForAppointments[index] == false || !vm.doctorAttendanceDataAdd[index].initial
              ? null
              : vm.doctorAttendanceDataAdd[index].initial.substr(0, 5),
          end:
            vm.openAgendaForAppointments[index] == false || !vm.doctorAttendanceDataAdd[index].end
              ? null
              : vm.doctorAttendanceDataAdd[index].end.substr(0, 5),
          days:
            vm.openAgendaForAppointments[index] == false
              ? null
              : vm.doctorAttendanceDataAdd[index].days,
          specialty: vm.doctorAttendanceDataAdd[index].specialty,
          customerPlan: vm.doctorAttendanceDataAdd[index].customerPlan,
          address: vm.openAgendaForAppointments[index]
            && vm.doctorAttendanceDataAdd[index].attendanceType === 1
            && vm.isProject
            ? vm.doctorAttendanceDataAdd[index].address
            : null,
        });
      }
      const changes = {
        id: vm.webClinic.id,
        webClinic: {
          id: vm.webClinic.webClinic.id,
          cnpj: vm.webClinic.webClinic.cnpj,
          name: vm.webClinic.webClinic.name,
          socialName: vm.webClinic.webClinic.socialName,
          legalRepresentative: vm.webClinic.webClinic.legalRepresentative,
          phone: vm.webClinic.webClinic.phone,
          contactEmail: vm.webClinic.webClinic.contactEmail,
          partner: vm.webClinic.webClinic.partner,
          address: vm.webClinic.webClinic.address,
          assistants: vm.webClinic.webClinic.assistants,
          active: vm.webClinic.webClinic.active,
          countDoctors: vm.webClinic.webClinic.countDoctors,
          isProject: vm.isProject,
        },
        doctor: vm.webClinic.doctor,
        accept: vm.webClinic.accept,
        mainAttendance: vm.webClinic.mainAttendance,
        attendances: attendancesFinal,
      };
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "doctor/clinic-doctors/" +
            vm.webClinic.id,
          changes,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          vm.$bvModal.hide("doctors-popup-doctor");
          if (response.status === 200) {
            vm.isSaving = false;
            vm.popupIsEditDoctor = false;
            vm.$swal({
              title: "Sucesso!",
              text: "Alterações realizadas com sucesso.",
              icon: "success",
            }).then(function () {
              vm.getDoctors();
            });
          }
        })
        .catch(function (error) {
          vm.isSaving = false;
          vm.popupIsEditDoctor = false;
          vm.$bvModal.hide("doctors-popup-doctor");
          vm.getDoctors();
          vm.showNotifyError("Não foi possível salvar as alterações", 6000);
          console.error({
            error: error,
            endpoint: "doctor/clinic-doctors/" + vm.webClinic.id,
            sent_object: changes,
            method: "saveChangesDoctor",
            http_method: "PUT",
          });
        });
    },
    postNewDoctor() {
      const vm = this;
      if (vm.isSaving) return;
      vm.isSaving = true;
      const doc = {
        name: "",
        crmNumber: "",
        crmState: "",
        cpf: "",
        email: "",
      };
      doc.name = vm.doctorAdd.name;
      doc.crmNumber = vm.doctorAdd.crmNumber;
      doc.crmState = vm.doctorAdd.crmState;
      doc.cpf = vm.doctorAdd.cpf;
      doc.email = vm.doctorAdd.email;
      doc.password = vm.doctorsAdd.password;
      vm.webClinic.doctor = doc;
      const specialtiesObjectArray = [];
      for (const a in vm.doctorAttendanceDataAdd) {
        console.log(vm.doctorAttendanceDataAdd[a].priceWithoutDiscount);
        console.log(vm.testNullUndefinedEmpty(vm.doctorAttendanceDataAdd[a].priceWithoutDiscount));
        vm.doctorAttendanceDataAdd[a].price =
          vm.testNullUndefinedEmpty(vm.doctorAttendanceDataAdd[a].price) ===
          false
            ? vm.doctorAttendanceDataAdd[a].price.replace(",", ".")
            : null;
            vm.testNullUndefinedEmpty(vm.doctorAttendanceDataAdd[a].priceWithoutDiscount) ===
          false ? vm.doctorAttendanceDataAdd[a].priceWithoutDiscount.replace(",", ".") : null;
      }
      const attendancesFinal = [];
      for (const index in vm.doctorAttendanceDataAdd) {
        attendancesFinal.push({
          webClinicId: vm.$session.get("clinicId"),
          attendanceType: vm.doctorAttendanceDataAdd[index].attendanceType,
          ignoreMatch:
            vm.openAgendaForAppointments[index]
              ? false
              : true,
          price:
            this.openAgendaForAppointments[index]
              ? this.doctorAttendanceDataAdd[index].price.replace(",", ".")
              : null,
              priceWithoutDiscount:
            this.openAgendaForAppointments[index]
              ? vm.testNullUndefinedEmpty(vm.doctorAttendanceDataAdd[index].priceWithoutDiscount) ===
          false ? this.doctorAttendanceDataAdd[index].priceWithoutDiscount.replace(",", ".") : null  : null ,
          initial:
            vm.openAgendaForAppointments[index] == false || !vm.doctorAttendanceDataAdd[index].initial
              ? null
              : vm.doctorAttendanceDataAdd[index].initial.substr(0, 5),
          end:
            vm.openAgendaForAppointments[index] == false || !vm.doctorAttendanceDataAdd[index].end
              ? null
              : vm.doctorAttendanceDataAdd[index].end.substr(0, 5),
          days:
            vm.openAgendaForAppointments[index] == false
              ? null
              : vm.doctorAttendanceDataAdd[index].days,
          specialty: vm.doctorAttendanceDataAdd[index].specialty,
          address: vm.openAgendaForAppointments[index]
          && vm.doctorAttendanceDataAdd[index].attendanceType === 1
          && vm.isProject
            ? vm.doctorAttendanceDataAdd[index].address
            : null,
        });
      }
      const doctor = {
        webClinicId: vm.$session.get("clinicId"),
        name: vm.doctorAdd.name,
        crmNumber: vm.doctorAdd.crmNumber,
        crmState: vm.doctorAdd.crmState,
        cpf: vm.doctorAdd.cpf,
        email: vm.doctorAdd.email,
        specialties: specialtiesObjectArray,
        attendances: attendancesFinal,
        password: vm.doctorAdd.password,
      };
      vm.axios
        .post(vm.$store.state.filooServer + "signup/doctor-from-clinic", doctor)
        .then(function (response) {
          vm.$bvModal.hide("doctors-popup-doctor");
          if (response.status === 201) {
            vm.isSaving = false;
            vm.$swal({
              title: "Sucesso!",
              text: "Cadastro realizado com sucesso.",
              icon: "success",
            }).then(function () {
              vm.getDoctors();
            });
          }
        })
        .catch(function (error) {
          vm.isSaving = false;
          vm.newDoctorsAdd = [];
          vm.getDoctors();
          console.error({
            error: error,
            endpoint: "signup/doctorfromclinic",
            sent_object: doctor,
            method: "postNewDoctor",
            http_method: "POST",
          });
          if (error.status == 412) {
            vm.showNotifyWarning(
              "O e-mail do profissional inserido já consta em nossa base de dados. Insira um novo e-mail válido e tente novamente.",
              6000
            );
          } else {
            vm.showNotifyError(
              "Não foi possível cadastrar um novo profissional da saúde",
              6000
            );
          }
        });
    },
    removeSpecialty(index) {
      const vm = this;
      vm.specialtyToRemoveIndex = index;
      vm.$bvModal.show("modal-remove-specialty");
    },
    getPlans() {
      var vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "customerplan/default-plans/3", {
          headers: {
            Authorization: vm.$session.get("bearer")
          }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.plans = response.data;
          }
        });
    },
    getIsProject() {
      let vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "webclinics/check-is-project", {
          headers: {
            Authorization: vm.$session.get("bearer")
          }
        })
        .then(function(response) {
          vm.isProject = response.data;
          if (vm.isProject)
            vm.colLength = 3;
        });
    },
    async getZip(row) {
      let validZip = !!this.doctorAttendanceDataAdd[row].address.zipcode

      if (validZip) {
        const zipcode = this.doctorAttendanceDataAdd[row].address.zipcode.replace(/\D/g, "")
        validZip = zipcode.length === 8
        
        if (validZip) {
          const response = await this.getAddressByZipcode(zipcode)
          validZip = !!response && !!response.address

          if (validZip) {
            this.doctorAttendanceDataAdd[row].address.street = response.address.street
            this.doctorAttendanceDataAdd[row].address.enableAddressStreet = !response.address
            this.doctorAttendanceDataAdd[row].address.city = response.address.city
            this.doctorAttendanceDataAdd[row].address.state = response.address.state
            this.doctorAttendanceDataAdd[row].address.neighborhood = response.address.neighborhood
          }
        }
      }

      if (!validZip) {
        this.doctorAttendanceDataAdd[row].address.invalidFields.zipcode = true
        this.doctorAttendanceDataAdd[row].address.invalidFields.city = true
        this.doctorAttendanceDataAdd[row].address.invalidFields.street = true
        this.doctorAttendanceDataAdd[row].address.invalidFields.state = true
      }
    },
    validateAddressFields(value, attendanceType) {
      let vm = this;
      if (vm.isProject && attendanceType === 1) {
        value.invalidFields.zipcode = (vm.testNullUndefinedEmpty(value)
          || vm.testNullUndefinedEmpty(value.zipcode))
        value.invalidFields.street = (vm.testNullUndefinedEmpty(value)
          || vm.testNullUndefinedEmpty(value.street));
        value.invalidFields.number = (vm.testNullUndefinedEmpty(value)
          || vm.testNullUndefinedEmpty(value.number));
        value.invalidFields.city = (vm.testNullUndefinedEmpty(value)
          || vm.testNullUndefinedEmpty(value.city));
        value.invalidFields.state = (vm.testNullUndefinedEmpty(value)
          || vm.testNullUndefinedEmpty(value.state));

        vm.invalidFields.address = value.invalidFields.zipcode
          || value.invalidFields.street
          || value.invalidFields.number
          || value.invalidFields.city
          || value.invalidFields.state;

        this.$forceUpdate();

      } else {
        vm.invalidFields.address = false;
      }
    }
  },
};
</script>

<style lang="scss" src="./Doctors.scss" />
